import Content, { ContentNS } from "content/content";
import useGeneralAnalytics from "features/shared/hooks/analytics/useGeneralAnalytics";
import PageHeader from "features/shared/styles/page-header/PageHeader.styled";
import Body from "features/shared/styles/typography/Body.styled";
import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";
import { FC } from "react";
import { Outlet } from "react-router-dom";
import { useAppStore } from "store/store";

import CallToActionBanner from "./components/cta-banner/CallToActionBanner";
import StyledConsentPage from "./styles/StyledConsentForm.styled";
import ChecklistResolutionStatus from "models/checklist/checklist-resolution-status";

const ConsentPage: FC = () => {
  useAppStore((state) => state.locale);
  useGeneralAnalytics();

  const text = (s: string) => Content.shared.t(s, { ns: ContentNS.consent });

  const ctaBannerContentExist = text("cta-banner") !== "cta-banner";

  const paxSessions = useAppStore((state) => state.paxSessions);
  const allResolved = paxSessions.every(
    (pax) =>
      pax.checklist.resolutionStatus === ChecklistResolutionStatus.ReadyToFly
  );

  return (
    <StyledConsentPage>
      {ctaBannerContentExist && !allResolved ? (
        <CallToActionBanner />
      ) : (
        <PageHeader>
          <TertiaryHeader>{text("title")}</TertiaryHeader>
          <Body>{text("subtitle")}</Body>
        </PageHeader>
      )}

      <Outlet />
    </StyledConsentPage>
  );
};

export default ConsentPage;
